import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/filters'

import Vant from 'vant'
import 'vant/lib/index.css'
import '@vant/touch-emulator';
Vue.use(Vant)

import fastClick from "fastclick"
fastClick.attach(document.body)

import axios from 'axios'
Vue.prototype.$axios = axios;


import CONSTANT from "./utils/constant";
Vue.prototype.CONSTANT = CONSTANT;

// import Vconsole from 'vconsole'
// if (/sandbox|localhost|10.1.30.79|127\.0.0.1/i.test(location.hostname)) {
// 	let vConsole = new Vconsole();
// 	Vue.use(vConsole);
// }


router.beforeEach((to, from, next)=>{
  if(to.meta.title){
    document.title = to.meta.title
  }
  next()
})

import less from 'less'
Vue.use(less)


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
